export default{
    async getQuestionList({ commit }, searchParam){
        let sort = [];
        for (let i = 0; i < searchParam.options.sortBy.length; i++) {
            sort[i] = {
                key: searchParam.options.sortBy[i],
                asc: !searchParam.options.sortDesc[i]
            };
        }
        let searchData = {
            page: searchParam.options.page,
            per_page: searchParam.options.itemsPerPage,
            sort: sort,
            search: { ...searchParam.searchKeys }
        };
        commit('setSearchingData', searchData, {root: false});
        return await this.$axios.$post(
            this.$api.tenantAdmin.questionList.list,
            searchData
        )
    },

    async getQuestion({}, id){
        return await this.$axios.$post(
            this.$api.tenantAdmin.questionList.questionDetail,
            {inquiry_number : id}
        )
    },

    async editQuestion({}, questionData){
        let result = null;
		let formData = new FormData;
		for (let iName in questionData.inquiry) {
			if (iName != 'user' && iName != 'tenant_name') {
				formData.append('inquiry['+iName+']', questionData.inquiry[iName]);
			}
		}
		for (let uName in questionData.user) {
			if (uName == 'tenant_name') {
				formData.append('inquiry['+uName+']', questionData.user[uName]);
			} else {
				formData.append('inquiry[user]['+uName+']', questionData.user[uName]);
			}
		}
		questionData.files.forEach(file => formData.append('admin_files[]', file));
        await this.$axios.$post(
            this.$api.tenantAdmin.questionList.questionEdit,
            formData
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },

    downloadAttachFile({}, param){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.questionList.downloadAttachFile, param)
        .catch(error => {
        });
    },
    
    async getCategoryList() {
        return await this.$axios.$get(
            this.$api.tenantAdmin.questionList.getCategoryList
        )
    },
    
    async addQuestion({}, submitData) {
        let result = null;
        let formData = new FormData;
        for (let qName in submitData.question) {
            if (qName === 'files') {
                submitData.question[qName].forEach(file =>
                    formData.append('files[]', file)
                );
            } else {
                formData.append(qName, submitData.question[qName]);
            }
        }
        let uKey;
        for (let uName in submitData.user) {
            switch (uName) {
                case 'affiliation':
                    uKey = 'user_affiliation';
                    break;
                case 'email_office':
                    uKey = 'user_email';
                    break;
                default:
                    uKey = uName;
            }
            formData.append(uKey, submitData.user[uName]);
        }
        for (let sName in submitData.support) {
            formData.append(sName, submitData.support[sName]);
        }
        await this.$axios.$post(
            this.$api.tenantAdmin.questionList.addQuestion,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
    
    getTenantList() {
        return this.$axios.$get(
            this.$api.systemAdmin.questionList.getTenantList
        )
        .then(res => {
            return res.tenant_list
        })
    },

    downloadAdminFile({}, param){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.questionList.downloadAdminFile, param)
        .catch(error => {
        });
    },
}
